const emailConfirmationDialog = state => state.common.emailConfirmationDialog ?? 'closed'

export { emailConfirmationDialog }
